
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/settings/profile",
      function () {
        return require("private-next-pages/my/settings/profile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/settings/profile"])
      });
    }
  